export default "__VITE_ASSET__BLyNapw5__"